import { FormattedMessage } from "react-intl";

import Avatar from "@atlaskit/avatar";
import Heading from "@atlaskit/heading";
import { Flex, Stack } from "@atlaskit/primitives-next";
import { Text } from "@atlaskit/primitives-next";

import { messages } from "./messages";

export const CardRelationship = ({
    name,
    imageUrl,
    titleMessage
}: {
    name: string;
    imageUrl: string;
    titleMessage: React.ReactNode;
}) => {
    return (
        <Flex alignItems="center" gap="space.150">
            <Avatar
                appearance="circle"
                src={imageUrl}
                size="large"
                name={name}
            />
            <Stack>
                <Heading size="xsmall">
                    <FormattedMessage
                        {...messages.cardRelationshipNameMessage}
                        values={{ name }}
                    />
                </Heading>
                <Text>{titleMessage}</Text>
            </Stack>
        </Flex>
    );
};
